<template>
    <div>
        <section>
            <!-- Header -->
            <div class="ns-user-groups-header flex items-center justify-between">
                <InputText v-model="search_user_group" style="min-width: 350px;" placeholder="Search" theme="regular" :show-icon="true" :set-icon="'el-icon-search'" />
                <Button button-text="New Group" :icon-before="add_icon" :button-type="'light'" @click="redirectToUi('/user-group/add')" />
            </div>
            <!-- Table section -->
            <div v-if="allUserGroups.length" class="ns-table-section">
                <div v-if="bulk_delete_ids.length"  class="flex items-center">
                    <span class="mr-5 text-sm">Selected Count: <strong>{{ bulk_delete_ids.length }}</strong> </span>
                    <Button button-text="Delete selected" :button-type="'primary'" @click="bulkGroupsDelete()" />
                </div>
                <table v-loading="get_user_groups_loading" class="ns-table">
                    <thead>
                        <tr>
                            <th> <el-checkbox v-model="select_all_user_groups" @change="selectAllGroups"></el-checkbox> </th>
                            <th>User Group</th>
                            <th>Group By</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in computeAllUsersGroup" :key="index">
                            <td><el-checkbox v-model="item.is_selected" @change="selectRecord(item.is_selected, item.id)"></el-checkbox></td>
                            <td style="font-weight: 600;">{{ item.name }}</td>
                            <td>
                                <el-tag class="mr-2 ns-tag capitalize" v-for="(tag, tag_index) in groupBy(item.id)" :key="tag_index">{{ tag }}</el-tag>
                            </td>
                            <td>
                                <img src="./../../../assets/icons/edit.png" alt="Edit" class="ns-tbl-edit-icon" @click="editGroup(item)">
                                <img src="./../../../assets/icons/delete_icon.png" alt="Delete" class="ns-tbl-delete-icon ml-5" @click="deleteGroup(item.id)">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else class="ns-empty-table">
                <div class="ns-card mt-5">
                    <el-empty description="User Groups are not found! "></el-empty>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import InputText from "../elements/InputText.vue"
import Button from "../elements/Button.vue"
import AddIcon from "../../../assets/icons/add_icon.svg"
import usersAndGroups from "../../../../mixins/usersAndGroups"
export default {
    name: "UserGroups",
    components: {
        InputText,
        Button
    },
    mixins: [usersAndGroups],
    data() {
        return {
            add_icon: AddIcon,
            select_all_user_groups: false,
            search_user_group: ''
        }
    },
    mounted() {
        this.getUserGroupsAction({store_id: null});
    },
}
</script>

<style lang="scss" scoped>
.ns-table-section{
    margin-top: 35px;
    height: 75vh;
    overflow-y: scroll;
}
.ns-table-section{
    background-color: #fff;
    padding: 15px;
    border-radius: 8px;
}

.ns-table-section {
    position: sticky;
    top: -15px;
    background: #fff;
    z-index: 2;
}

</style>